import React from 'react';
import { default as ReactModal } from 'react-modal';
import styled from 'styled-components';

import 'video-react/dist/video-react.css';
import { theme } from '../../theme';

interface Props {
  isOpen: boolean;
  onToggle: () => void;
  children: any;
  contentLabel?: string;
  style?: any;
  dialog?: boolean;
  className?: string;
  'data-test'?: string;
  allowOverflow?: boolean;
}

export function Modal(props: Props) {
  const { isOpen, children, contentLabel, style, className } = props;

  const overlayStyle = {
    zIndex: 999,
  };

  const customStyles = {
    content: {
      position: 'relative',
      top: 0,
      borderRadius: '10px',
      border: 'none',
      boxShadow: '0 1px 40px 1px rgba(53, 54, 56, 0.1)',
      backgroundColor: '#fcfcfe',
      padding: 0,
      maxWidth: '80vw',
      maxHeight: '80vh',
      inset: 0,
      ...style,
      overflow: 'visible',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    overlay: { ...overlayStyle },
  };

  const toggle = (e: any) => {
    props.onToggle();
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={toggle}
      style={className ? { content: style } : customStyles}
      contentLabel={contentLabel}
      ariaHideApp={false}
      className={className}
      shouldCloseOnEsc={!props.dialog}
      shouldCloseOnOverlayClick={!props.dialog}
    >
      {!props.dialog && (
        <Cross onClick={toggle} data-accesskey="Esc" aria-label="Close">
          ×
        </Cross>
      )}
      {props?.allowOverflow ?
        <div data-test={props['data-test']}>{children}</div>
        :
        <Overflow data-test={props['data-test']} onClick={(e) => e.stopPropagation()}>{children}</Overflow>
      }
    </ReactModal>
  );
}
const Overflow = styled.div`
  overflow: auto;
  width: 100%;
  height: 100%;
`;

const Cross = styled.button`
  width: 1.3em;
  height: 1.3em;
  display: block;
  outline: none;
  border: none;
  background: ${theme.primary.background};
  padding: 0;
  font-size: 2em;
  line-height: 1.2em;
  border-radius: 100%;
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom: calc(100% + 0.5em);
  box-shadow: 0 1px 40px 1px rgba(53, 54, 56, 0.1);
  text-align: center;
  font-weight: 600;
  color: #666;
  transition: 150ms ease all;

  &:hover {
    color: #000;
  }
`;

export default Modal;
